import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, IProfileFilter, ITree, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import * as _ from "lodash"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {CustomerSearch} from "../PA.UIM.MD/CustomerSearch";
import {PlanningLevelSearch} from "./PlanningLevelSearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {ProductSearch} from "../PA.UIM.MD/ProductSearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const TPMPlanSearch: ISearch = {
    searchName: "Find SVF",
    renderOptions: {ui5ResourceId: "TPMPlanSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: []
}

const vUI_TPM_Plan_Search_Fields: { [id: string]: ISearchProviderField } = {

    WB_PLAN_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB Plan Id', columnResourceName: 'colId', alignment: HorizAlignment.Center},
        domainOptions: {}
    },
    PLAN_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Plan Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    PLAN_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Plan Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },

    WB_CUST_ID_PLANNING: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Planning Cust WB Id',
            columnResourceName: 'colPlnCstId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {search: CustomerSearch, profileId: "MyPlanningCustomers", searchCondition: {}}
    },
    PLANNING_CUSTOMER_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Planning Customer',
            columnResourceName: 'colPlnCst',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },

    PLANNING_CUSTOMER_TREE_PATH: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Planning Customer',
            columnResourceName: 'colPlnCst',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },

    WB_PLANM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Plan Type ID',
            columnResourceName: 'colPlanTypeID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    PLANTYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Plan Type', columnResourceName: 'colPlanTypeName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },

    SALESORG: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Org', columnResourceName: 'colSalesOrg', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 20}
    },
    DIVISION: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Division', columnResourceName: 'colDivision', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 20}
    },
    DISTRIBCHANNEL: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Distrib Channel',
            columnResourceName: 'colDistribChannel',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 20}
    },

    INSTORE_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'InStore Start Dt',
            columnResourceName: 'colInStoreStart',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    INSTORE_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'InStore End Dt',
            columnResourceName: 'colInStoreEnd',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },

    SOURCE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Source ID', columnResourceName: 'colSourceId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50, source: true, useIdAsKey: true}
    },

    ACTIVE_IND: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Active Ind', columnResourceName: 'colActiveInd', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 5}
    },

    WB_PLNMGMT_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Plan Mgmt ID',
            columnResourceName: 'colPlanMgmtID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    PLAN_MANAGEMENT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Plan Management',
            columnResourceName: 'colPlanMagementName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },

    PLANNING_LEVEL_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Planning Level ID',
            columnResourceName: 'colLevelID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50, search: PlanningLevelSearch, profileId: "", searchCondition: {}}
    },
    PLANNING_LEVEL_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Planning Level',
            columnResourceName: 'colLevelName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },

    PLAN_PERIOD_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Plan Period',
            columnResourceName: 'colPlanPeriodName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: TPMPlanSearch,
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 256
        }
    },

    MANUAL_IND: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Manual Ind', columnResourceName: 'colManualInd', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 5}
    },

    EVENT_COUNT: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Event Count',
            columnResourceName: 'colEventCount',
            alignment: HorizAlignment.Right,
            numberFormat: "#,##0"
        },
        domainOptions: {}
    },

    LAST_CALC_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Last Calc Dt',
            columnResourceName: 'colLastCalcDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    LAST_CALC_TM: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Last Calc Tm',
            columnResourceName: 'colLastCalcTm',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    }

}

class TPMPlanSearchByCustomerSearchProvider
    implements ISearchProvider {

    planCustWBId: number = 0

    constructor(aWB_CUST_ID: number) {
        this.planCustWBId = aWB_CUST_ID
    }

    get keyFields() {
        return {
            id: 'WB_PLAN_ID',
            id_ui: 'PLAN_ID',
            name: 'PLAN_NAME',
            source_id: 'SOURCE_ID'
        }
    }

    get searchProviderFields() {
        return vUI_TPM_Plan_Search_Fields
    }

    search(requestSpec: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            requestSpec.where.WB_CUST_ID_PLANNING = this.planCustWBId
            let findRequest = SearchUtils.makeSearchRequest(requestSpec,
                'vUI_TPM_Plan_Search',
                this.searchProviderFields,
                [])
            if (_.isEmpty(findRequest.order)) {
                findRequest.order = ['PLANNING_CUSTOMER_NAME', 'PLANNING_LEVEL_NAME']
            }

            SearchUtils.addPlanManagementFilter(findRequest, 'WB_PLNMGMT_ID')
                .then((ignore) => {
                    return PASearch.findByRequest(findRequest)
                })
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })

    }
}


class TPMPlanSearchByCustomerProfile implements ISearchProfile {
    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "Search By Customer ID"
    renderOptions = {ui5ResourceId: "TPMPlanSearchByCustomerProfile"}

    profileFilter: IProfileFilter[] = [
        {profileFilterName: 'Plan Id', searchProviderFieldId: 'PLAN_ID', renderOptions: {}, bQuickSearch: true},
        {profileFilterName: 'Plan Name', searchProviderFieldId: 'PLAN_NAME', renderOptions: {}, bQuickSearch: true},
        {
            profileFilterName: 'Fiscal Year',
            searchProviderFieldId: 'PLAN_PERIOD_NAME',
            bMultiSelect: true,
            renderOptions: {}
        }
    ]

    profileDisplayFields = [
        'PLANNING_CUSTOMER_NAME', 'PLANNING_LEVEL_NAME', 'PLAN_PERIOD_NAME', 'PLANTYPE_NAME', 'PLAN_NAME', 'PLAN_ID', 'SOURCE_ID',
        {
            columnTitle: "InStore Dates",
            fields: ['INSTORE_START_DT', 'INSTORE_END_DT'],
            seperator: " - ",
            alignment: HorizAlignment.Center
        }
    ]

    profileTreeIdDefault = "default"
    profileTrees: ITree[] = []

    profileSortIdDefault = ""    //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];


    constructor(aWB_CUST_ID: number) {
        this.aSearchProvider = new TPMPlanSearchByCustomerSearchProvider(aWB_CUST_ID)
    }

    get profileSearchProvider() {
        return this.aSearchProvider
    }

}

export class TPMPlanSearchByCustomer
    implements ISearch {

    constructor(aWB_CUST_ID: number, options?: any) {
        this.searchProfiles = [new TPMPlanSearchByCustomerProfile(aWB_CUST_ID)]
    }

    searchName = "Select Plan(s)"
    renderOptions = {ui5ResourceId: "TPMPlanSearchByCustomer"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true

}
